import PropTypes from 'prop-types'
import { Component, createRef } from 'react'

import Button from 'components/common/Button'
import InputTextField from 'components/common/InputTextField'

export default class Email extends Component {
  static propTypes = {
    email: PropTypes.string,
    handleChange: PropTypes.func,
    inputIsDisabled: PropTypes.bool,
    isLoading: PropTypes.bool
  }

  constructor(props) {
    super(props)
    this.textInput = createRef()
  }

  componentDidMount() {
    this.textInput.focus()
  }

  setRef = (ref) => (this.textInput = ref)

  render() {
    return (
      <div className="formFields">
        <InputTextField
          data-test-email-input
          autoComplete="email"
          disabled={this.props.inputIsDisabled}
          innerRef={this.setRef}
          label="Email"
          name="email"
          value={this.props.email}
          onChange={this.props.handleChange}
        />
        <Button
          data-test-email-continue-button
          stretch
          disabled={!this.props.email.length || this.props.isLoading}
          label="Continue"
          type="submit"
        />
      </div>
    )
  }
}
